// extracted by mini-css-extract-plugin
export default {"amendAgreement":"no6OT","emptyField":"a_QIf","formSection":"ntNLY","requiredLabel":"HcbWV","formActions":"piS07","formBtn":"jI44S","container":"aBt1R"};